export interface OnboardingStatusSnapshot {
  isAdmin?: boolean;
  /** True once terms, account type, and an organization are in place. */
  access?: boolean;
  onboardingState?: { data?: { userType?: string } };
}

/**
 * Feature-flag refusals say "not enabled for your organization". That is a
 * dark feature, not a missing store, and must not restart onboarding.
 */
export function isFeatureDisabledForOrganization(errorMessage: string): boolean {
  return /not enabled for your organization/i.test(errorMessage);
}

/**
 * Where to send a 403 that mentions an organization. Null means leave the
 * response with the caller. A store that can already use the app stays put;
 * only someone who has not finished setup is sent back into onboarding.
 */
export function onboardingPathForOrganization403(
  errorMessage: string,
  errorCode: string | undefined,
  status: OnboardingStatusSnapshot | null | undefined,
): string | null {
  if (errorCode === 'organization_pending_approval') return null;
  if (isFeatureDisabledForOrganization(errorMessage)) return null;
  const mentionsSetup =
    errorMessage.includes('organization') || errorMessage.includes('onboarding');
  if (!mentionsSetup) return null;
  if (status?.isAdmin === true) return null;
  if (status?.access === true) return null;

  const userType = status?.onboardingState?.data?.userType;
  if (userType === 'store') return '/onboarding/setup-store';
  if (userType === 'vendor' || userType === 'vendor_supplier') return '/onboarding/setup-vendor';
  return '/onboarding/select-type';
}
